export const main_url = process.env.REACT_APP_API_URL || "";
export const DARK_BLUE = '#1a245aff';

export const relatedModelMap = {
  1: 'projects.Project',
  2: 'patients.Patient',
  3: 'patients.PatientProjectExecution',
};

export const attachmentName = {
  1: 'Project_attachment',
  2: 'Patient_attachment',
  3: 'Execution_attachment',
};

// #2a366e
